module.exports = __webpack_public_path__ + "static/media/21ECLAC38.79373c6d.jpg";